import { PageEvent } from '@angular/material/paginator';
import { ISession } from '@models';
import { ODataFilterBuilder } from '@pages/generics/filter-builder/odata';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { MapperDefinition } from '@services/mapper.service';
import {
    IFilterModel,
    ISortModel,
} from '@uipath/angular/components/ui-grid';

export class RobotFilterBuilder extends ODataFilterBuilder<ISession> {
    public build(
        page: PageEvent,
        sort: ISortModel<ISession>,
        searchFilters: IFilterModel<ISession>[],
        filters: IFilterModel<ISession>[],
        expand: string[],
        select: string[],
        mapper: MapperDefinition<ISession>,
    ): ODataQueryOptions {

        const options = super.build(
            page,
            sort,
            searchFilters,
            filters,
            expand,
            select,
            mapper,
        );

        if (
            options.orderBy &&
            options.orderBy[0] &&
            options.orderBy[0].startsWith(mapper.state.toString())
        ) {
            const stateSort = options.orderBy[0].split(' ')[1];
            options.orderBy.unshift(mapper.isUnresponsive + ' ' + stateSort);
        }

        return options;
    }
}
